export default function generateWhatsappURL({
  phoneNumber,
  message,
}: {
  phoneNumber: string;
  message: string;
}) {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return isMobile
    ? `whatsapp://send?phone=${phoneNumber}&text=${message}`
    : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
}
